import { ciContains } from 'legacy/lut/helpers/comparison/ciContains'

import { IPartnerFlag } from 'clickNgo/entities/partner/models/partnerFlag'

export const filterPartnerFlagList = (partnerFlag: IPartnerFlag, searchKey: string) => {
  if (searchKey) {
    return ciContains(partnerFlag.codeName, searchKey) || ciContains(partnerFlag.code, searchKey)
  }

  return true
}
